import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private _loading = signal(false);
  private _slowConnection = signal(false);

  get loading() {
    return this._loading();
  }

  get slowConnection() {
    return this._slowConnection();
  }

  setLoading(isLoading: boolean) {
    this._loading.set(isLoading);
  }

  setSlowConnection(isSlow: boolean) {
    this._slowConnection.set(isSlow);
  }
}
